import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { useDialogManager } from '../DialogManager/useDialogManager.js';
import { LocationDialog } from './LocationDialog.js';
export const useLocationDialog = (props) => {
    const { open, close } = useDialogManager();
    return {
        open: (options = {}) => open(_jsx(LocationDialog, { ...props }), options),
        close,
    };
};
//# sourceMappingURL=useLocationDialog.js.map